import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSearchParams, useSubmit } from 'react-router-dom'
import useUpdateMode from '../../../hooks/useUpdateMode'
import { saveAnswer } from '../../../utils/onboardingStorage'

const QUESTION_KEY = 'transformationGoal'

const OPTIONS = [
  {
    value: 'Feel more at home',
    translationKey: 'pages.onboarding.v1.transformationGoal.options.feelHome',
    emoji: '🏠',
  },
  {
    value: 'Impress guests',
    translationKey:
      'pages.onboarding.v1.transformationGoal.options.impressGuests',
    emoji: '✨',
  },
  {
    value: 'Boost productivity',
    translationKey:
      'pages.onboarding.v1.transformationGoal.options.productivity',
    emoji: '💼',
  },
  {
    value: 'Reduce stress',
    translationKey:
      'pages.onboarding.v1.transformationGoal.options.reduceStress',
    emoji: '🧘',
  },
  {
    value: 'Just curious',
    translationKey: 'pages.onboarding.v1.transformationGoal.options.curious',
    emoji: '🔍',
  },
]

export default function TransformationGoalPage() {
  const submit = useSubmit()
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value && OPTIONS.some((option) => option.value === value)
      ? value
      : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const value = formData.get('answer') as string

    if (!value) return

    const answer = {
      question_key: QUESTION_KEY,
      question: "What's driving your desire to transform your space?",
      answer_key: value,
      answer: value,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(event.currentTarget)
    }
  }

  const buttons = OPTIONS.map((option) => ({
    text: `${option.emoji} ${t(option.translationKey)}`,
    value: option.value,
  }))

  return (
    <QuestionPage
      heading={t('pages.onboarding.v1.transformationGoal.heading')}
      buttons={buttons}
      onSubmit={handleSubmit}
      headingSize="text-3xl text-center whitespace-pre-line"
      buttonTextSize="text-xl"
      buttonBgColor="bg-white"
      preselectedValue={preselectedValue}
    />
  )
}
